import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./utils/vant";
import "./assets/scss/index.scss";
// import Xes_Log from './utils/event_track'

// Vue.prototype.$Xes_Log = Xes_Log

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
